import { useCallback } from 'react';
import { AblyRealtimeProvider } from 'ably-hubspot-js/v3/AblyRealtimeProvider';
import { AblyChannelProvider } from 'ably-hubspot-js/v3/AblyChannelProvider';
import { useCreateAuthTokenMutation } from '../../__generated__/chirp/com/hubspot/copilot/rpc/CopilotChatService.hooks';
import { ABLY_ID } from '../consts';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
export function AcademyChatProvider({
  thread,
  userId,
  children
}) {
  const [createAuthToken] = useCreateAuthTokenMutation();
  const authCallback = useCallback((_tokenParams, callback) => {
    createAuthToken({
      variables: {
        clientId: userId.toString(),
        threadId: thread.id
      }
    }).then(result => {
      var _result$data;
      const token = (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.result;
      if (!token) {
        callback(new Error(I18n.text('academy-ai-assistant.errors.authFailed')), null);
      } else {
        callback(null, token);
      }
    }).catch(err => {
      callback(err, null);
    });
  }, [createAuthToken, userId, thread.id]);
  return /*#__PURE__*/_jsx(AblyRealtimeProvider, {
    ablyId: ABLY_ID,
    authCallback: authCallback,
    children: /*#__PURE__*/_jsx(AblyChannelProvider, {
      ablyId: ABLY_ID,
      channelName: thread.ablyChannelId,
      children: children
    })
  });
}